<template>
  <div>
    <table class="full-width" border="1" style="border-collapse: collapse">
      <thead>
        <tr>
          <th>Thứ</th>
          <th>Buổi</th>
          <th class="px-1">Tiết</th>
          <th class="px-2">Môn</th>
          <th class="pa-1">
            Tiết
            <div>
              theo
            </div>
            <div>
              PPCT
            </div>
          </th>
          <th class="px-2">Nội dung bài học</th>
          <th class="px-2">Chi tiết lớp học</th>
          <th class="px-2">Đánh giá</th>
          <th class="px-2">Giáo viên</th>
          <th class="px-1">-</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="section in 60" :key="section">
          <!-- thứ -->
          <td class="px-1 text-center" rowspan="10" v-if="(section - 1) % 10 === 0">
            <div class="d-flex flex-column text-center">
              <div>
                {{ ((section - 1) / 10 + 1) | scheduleDay }}
              </div>
              <div>
                {{
                  moment(startWeek)
                    .startOf('day')
                    .add((section - 1) / 10, 'day')
                    .toISOString() | ddmmyyyy
                }}
              </div>
            </div>
          </td>
          <!-- buổi -->
          <td class="px-1 text-center" rowspan="5" v-if="(section - 1) % 5 === 0">
            <span v-if="((section - 1) / 5) % 2 === 0">
              Sáng
            </span>
            <span v-else>
              Chiều
            </span>
          </td>
          <!-- tiết -->
          <td class="text-center">
            {{ ((section - 1) % 10) + 1 }}
          </td>
          <!-- môn -->
          <td class="px-1 text-center">
            <div
              v-if="
                $_get(
                  classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                  'slot.classNote.metadata.slot.subject.title'
                )
              "
            >
              {{
                $_get(
                  classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                  'slot.classNote.metadata.slot.subject.title'
                )
              }}
            </div>
            <div v-else>
              {{
                $_get(
                  classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                  'teaching.subject.title'
                )
              }}
            </div>
          </td>
          <!-- tiết theo PPCT -->
          <td class="text-center">
            {{
              $_get(
                classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                'slot.classNote.data.lessonIndex'
              )
            }}
          </td>
          <!-- nội dung bài học -->
          <td class="pl-2 pr-1">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div v-on="on" class="truncate-text-2">
                  {{
                    $_get(
                      classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                      'slot.classNote.lesson'
                    )
                  }}
                </div>
              </template>
              <span>
                {{
                  $_get(
                    classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                    'slot.classNote.lesson'
                  )
                }}
              </span>
            </v-tooltip>
          </td>
          <!-- chi tiết lớp học -->
          <td class="pl-2 pr-1">
            <!-- violation -->
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <div
                    v-if="
                      $_get(
                        classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                        'slot.classNote.currentViolations.length'
                      )
                    "
                    class="truncate-text-1"
                  >
                    - Em
                    <span
                      v-for="(violation, index) in $_get(
                        classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                        'slot.classNote.currentViolations'
                      )"
                      :key="violation.id"
                    >
                      {{ violation | _get('student.name') }}: {{ violation.description }}
                      <span
                        v-if="
                          index + 1 <
                            $_get(
                              classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                              'slot.classNote.currentViolations.length'
                            )
                        "
                        >,</span
                      >
                    </span>
                  </div>
                </div>
              </template>
              <span>
                - Em
                <span
                  v-for="(violation, index) in $_get(
                    classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                    'slot.classNote.currentViolations'
                  )"
                  :key="violation.id"
                >
                  {{ violation | _get('student.name') }}: {{ violation.description }}
                  <span
                    v-if="
                      index + 1 <
                        $_get(
                          classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                          'slot.classNote.currentViolations.length'
                        )
                    "
                    >,</span
                  >
                </span>
              </span>
            </v-tooltip>
            <!-- mark -->
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <div
                    v-if="
                      $_get(
                        classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                        'slot.classNote.currentMarks.length'
                      )
                    "
                    class="truncate-text-1"
                  >
                    - Em
                    <span
                      v-for="(mark, index) in $_get(
                        classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                        'slot.classNote.currentMarks'
                      )"
                      :key="mark.id"
                    >
                      {{ mark | _get('student.name') }}:
                      <span v-if="mark.subject.markType === 'mark'"> {{ mark.value }} điểm </span>
                      <span v-else>
                        {{ mark.value | getEvaluate }}
                      </span>
                      <span
                        v-if="
                          index + 1 <
                            $_get(
                              classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                              'slot.classNote.currentMarks.length'
                            )
                        "
                        >,</span
                      >
                    </span>
                  </div>
                </div>
              </template>
              <span>
                - Em
                <span
                  v-for="(mark, index) in $_get(
                    classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                    'slot.classNote.currentMarks'
                  )"
                  :key="mark.id"
                >
                  {{ mark | _get('student.name') }}: {{ mark.value }} điểm
                  <span
                    v-if="
                      index + 1 <
                        $_get(
                          classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                          'slot.classNote.currentMarks.length'
                        )
                    "
                    >,</span
                  >
                </span>
              </span>
            </v-tooltip>
          </td>
          <!-- đánh giá -->
          <td class="pl-2 pr-1">
            <div
              v-if="
                $_get(
                  classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                  'slot.classNote.data.classMark'
                )
              "
            >
              {{
                $_get(
                  classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                  'slot.classNote.data.classMark'
                )
              }}
              điểm
            </div>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div v-on="on" class="truncate-text-1">
                  {{
                    $_get(
                      classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                      'slot.classNote.data.classComment'
                    )
                  }}
                </div>
              </template>
              <span>
                {{
                  $_get(
                    classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                    'slot.classNote.data.classComment'
                  )
                }}
              </span>
            </v-tooltip>
          </td>
          <!-- giáo viên -->
          <td class="text-center px-1" style="width: 100px; height: 50px">
            <router-link
              target="_blank"
              v-if="
                $_get(
                  classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                  'slot.classNote.metadata.slot.teacher.name'
                )
              "
              :to="
                '/teacher/' +
                  $_get(
                    classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                    'slot.classNote.metadata.slot.teacher.name'
                  )
              "
              style="text-decoration: none !important"
            >
              <div>
                {{
                  $_get(
                    classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                    'slot.classNote.metadata.slot.teacher.name'
                  )
                }}
              </div>
            </router-link>
            <router-link
              target="_blank"
              v-else
              :to="
                '/teacher/' +
                  $_get(
                    classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                    'teaching.teacher.id'
                  )
              "
              style="text-decoration: none !important"
            >
              <div>
                {{
                  $_get(
                    classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                    'teaching.teacher.name'
                  )
                }}
              </div>
            </router-link>
          </td>
          <!-- thao tác -->
          <td class="text-center px-1" style="width: 10px">
            <v-icon
              color="primary"
              class="cursor-pointer"
              v-if="
                $_get(classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`], 'teaching')
              "
              @click="
                viewDetail(
                  classNoteSlots[`${((section - 1) % 10) + 1}-${Math.floor((section - 1) / 10 + 1)}`],
                  moment(startWeek)
                    .startOf('day')
                    .add((section - 1) / 10, 'day')
                    .toISOString()
                )
              "
              >mdi-eye</v-icon
            >
          </td>
        </tr>
      </tbody>
    </table>

    <TeachingReportDetailDialog :state="detailDialog" :currentSlot="currentSlot" :currentDate="currentDate" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {
    TeachingReportDetailDialog: () => import('@/modules/teachingReport/TeachingReportDetailDialog.vue')
  },
  data() {
    return {
      moment: moment,
      detailDialog: false,
      currentSlot: null,
      currentDate: ''
    }
  },
  computed: {
    ...mapGetters('TeachingReport', ['startWeek', 'endWeek']),
    ...mapState('timeTable', ['classNoteSlots'])
  },
  methods: {
    viewDetail(item, date) {
      this.detailDialog = !this.detailDialog
      this.currentDate = date
      this.currentSlot = { ...item }
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  tr {
    border: 1px solid black;
    width: 100% !important;
  }

  color: #212121;
  border-collapse: collapse;
  width: 100%;
}
.border {
  border: 1px solid gray;
  border-width: thin !important;
}
.truncate-text-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.truncate-text-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
